import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import IncomingCallScreen from './Screens/IncomingCallScreen';
import ComplaintFormScreen from './Screens/ComplaintFormScreen';
import InquiryFormScreen from './Screens/InquiryFormScreen';
import ServiceRequestFormScreen from './Screens/ServiceRequestFormScreen';
import CalLlogsScreen from './Screens/CalLlogsScreen';
import ContactScreen from './Screens/ContactScreen';
import TicketScreen from './Screens/TicketScreen';
import UpdateInquiryFormScreen from './Screens/UpdateInquiryFormScreen';
import UpdateComplaintFormScreen from './Screens/UpdateComplaintFormScreen';
import UpdateServiceRequestFormScreen from './Screens/UpdateServiceRequestFormScreen';
import LoginScreen from './Screens/LoginScreen';
import SignupScreen from './Screens/SignupScreen';
import AdminList from './Screens/AdminList';
import { AuthContextProvider } from './store/auth-context';
import ErrorPage from './Screens/ErrorPage';
import Navbar from './components/Navbar';
import TicketMidleWare from './Screens/TicketMidleWare';
import { DropdownContextProvider } from './store/dropdown-context';
import { QueryClient, QueryClientProvider } from 'react-query';
const queryClient = new QueryClient();

function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <DropdownContextProvider>
          <Navbar />

          <Routes>
            <Route
              path='/IncomingCallScreen/:phoneNumber'
              element={<IncomingCallScreen />}
            />
            <Route
              path='/ComplaintFormScreen/:phoneNumber'
              element={<ComplaintFormScreen />}
            />
            <Route
              path='InquiryFormScreen/:phoneNumber'
              element={<InquiryFormScreen />}
            />
            <Route
              path='ServiceRequestFormScreen/:phoneNumber'
              element={<ServiceRequestFormScreen />}
            />
            <Route
              path='/CalLlogsScreen/:phoneNumber'
              element={<CalLlogsScreen />}
            />
            <Route path='/:phoneNumber' element={<ContactScreen />} />
            <Route
              path='/:phoneNumber/:agentName'
              element={<ContactScreen />}
            />
            <Route path='/' element={<ContactScreen />} />
            <Route
              path='ticket/:phoneNumber/:id'
              element={<TicketMidleWare />}
            />
            <Route
              path='UpdateInquiryFormScreen/:phoneNumber/:id'
              element={<UpdateInquiryFormScreen />}
            />
            <Route
              path='UpdateServiceRequestFormScreen/:phoneNumber/:id'
              element={<UpdateServiceRequestFormScreen />}
            />
            <Route
              path='UpdateComplaintFormScreen/:phoneNumber/:id'
              element={<UpdateComplaintFormScreen />}
            />
            <Route path='/login' element={<LoginScreen />} />
            {/* <Route path='/admin' element={<AdminList />} />
          <Route
            path='/admin/page/:pageNumber/pageSize/:pageSize'
            element={<AdminList />}
            exact
          />
          <Route path='/admin/search/:keyword' element={<AdminList />} exact />
          <Route
            path='/admin/search/:keyword/page/:pageNumber/pageSize/:pageSize'
            element={<AdminList />}
            exact
          />
          <Route path='/login' element={<LoginScreen />} />
          <Route path='/signup' element={<SignupScreen />} />
          <Route path='*' element={<ErrorPage />} /> */}
          </Routes>
        </DropdownContextProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
